import { Component } from '@theme/component';

/**
 * Filters the FAQ page by topic while keeping every answer in a native accordion.
 * @extends {Component}
 */
class FaqFilterComponent extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.querySelectorAll('[data-topic-filter]').forEach((button) => {
      button.disabled = false;
    });
  }

  selectTopic(event) {
    const button = event.target.closest('[data-topic-filter]');
    if (!button || !this.contains(button)) return;

    const selectedTopic = button.dataset.topicFilter;

    this.querySelectorAll('[data-topic-filter]').forEach((filter) => {
      filter.setAttribute('aria-pressed', String(filter === button));
    });

    this.querySelectorAll('[data-topic-group]').forEach((group) => {
      group.hidden = selectedTopic !== 'all' && group.dataset.topicGroup !== selectedTopic;
    });
  }
}

if (!customElements.get('faq-filter-component')) {
  customElements.define('faq-filter-component', FaqFilterComponent);
}
